import React from "react";

const Button = ({
  children,
  backgroundColor,
  onClick,
}: {
  children: React.ReactNode;
  backgroundColor?: string;
  onClick: () => void;
}) => {
  return (
    <div
      className="content-btn"
      style={{
        backgroundColor: backgroundColor ? backgroundColor : "#4A90F7",
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Button;
